import {
  LayoutDashboard, Store, TrendingUp, Wallet, Boxes, ChefHat, ShoppingCart,
  Truck, Receipt, Target, LineChart, FileBarChart, Users, CheckSquare,
  Bell, ScrollText, Settings, ShieldCheck,
} from "lucide-react";

export const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, perm: "dashboard:view" },
  { to: "/outlets", label: "Outlets", icon: Store, perm: "outlets:view" },
  { to: "/sales", label: "Sales / Revenue", icon: TrendingUp, perm: "sales:view" },
  { to: "/cash", label: "Cash Management", icon: Wallet, perm: "cash:view" },
  { to: "/inventory", label: "Inventory", icon: Boxes, perm: "inventory:view" },
  { to: "/recipes", label: "Recipe / Food Cost", icon: ChefHat, perm: "recipes:view" },
  { to: "/procurement", label: "Procurement", icon: ShoppingCart, perm: "procurement:view" },
  { to: "/suppliers", label: "Suppliers", icon: Truck, perm: "suppliers:view" },
  { to: "/expenses", label: "Expenses", icon: Receipt, perm: "expenses:view" },
  { to: "/budget", label: "Budget", icon: Target, perm: "budget:view" },
  { to: "/pnl", label: "Profit & Loss", icon: LineChart, perm: "pnl:view" },
  { to: "/reports", label: "Reports", icon: FileBarChart, perm: "reports:view" },
  { to: "/users", label: "Staff / Users", icon: Users, perm: "users:view" },
  { to: "/roles", label: "Roles & Permissions", icon: ShieldCheck, perm: "users:edit" },
  { to: "/approvals", label: "Approvals", icon: CheckSquare, perm: "approvals:view" },
  { to: "/notifications", label: "Notifications", icon: Bell, perm: "notifications:view" },
  { to: "/audit", label: "Audit Logs", icon: ScrollText, perm: "audit:view" },
  { to: "/settings", label: "Settings", icon: Settings, perm: "settings:view" },
];
